/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InApp/view.blocks to change it.
import Email from './Email/index'
import Name from './Name/index'
import PracticeHubAccountStatus from './PracticeHubAccountStatus/index'
import React from 'react'
import SecureIcon from 'DesignSystem/Svgs/SecureIcon/index'
import StatusTooltip from './StatusTooltip/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function InApp({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/InApp",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="InApp.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<SecureIcon
  viewPath={`${viewPath}/SecureIcon`}
 marginRight={6}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
<StatusTooltip
  viewPath={`${viewPath}/StatusTooltip`}
 flowNo={!isHovered}
 flowContent={isHovered}
/>
</button>
<div
  data-testid="InApp.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="InApp.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<PracticeHubAccountStatus
  viewPath={`${viewPath}/PracticeHubAccountStatus`}
/>
</div>
<Email
  viewPath={`${viewPath}/Email`}
/>
</div>
{children}
</React.Fragment>)
}